var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":"/images/logo.png","width":_vm.width,"height":_vm.height,"contain":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }